<template>
  <div v-if="loading">
    <loading />
  </div>
  <div v-else>
    <v-card elevation="4">
      <v-app-bar flat dense elevation="0" color="transparent" width="100%">
        <v-tool-bar-content class="w-100">
          <div class="d-flex justify-space-between align-center">
            <v-toolbar-title> <h4>Shipment Profile Rates</h4> </v-toolbar-title>
            <div>
              <v-btn @click="$emit('add')" fab dark small color="primary">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </v-tool-bar-content>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0" v-if="!loading">
        <template>
          <v-data-table
            :headers="headers"
            :items="shipmentProfileRates"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
            @click:row="edit($event.id)"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:item.method="{ item }">
              {{ item.method.replace("_", " ") }}
            </template>

            <template v-slot:item.action="{ item }" v-if="actions">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
export default {
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10,
          shipmentProfileId: null
        };
      }
    },
    module: {
      type: String,
      default: "shipmentprofilerates/LOAD_SHIPMENT_PROFILE_RATES"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Max Price",
          align: "left",
          sortable: false,
          value: "maxPrice"
        },
        {
          text: "Min Price",
          align: "left",
          sortable: false,
          value: "minPrice"
        },
        {
          text: "Min Weight",
          align: "left",
          sortable: false,
          value: "minWeight"
        },
        {
          text: "Max Weight",
          align: "left",
          sortable: false,
          value: "maxWeight"
        },
        { text: "", value: "action", align: "right" }
      ]
    };
  },
  computed: {
    shipmentProfileRates() {
      return this.$store.state.shipmentprofilerates.shipmentProfileRates;
    },
    totalItems() {
      return this.$store.state.shipmentprofilerates.total;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  created() {
    if (this.actions == false) {
      this.headers = this.headers.filter(column => column.value !== "action");
    }
    setTimeout(() => {
      this.getShipmentProfileRates(this.payload);
    }, 1000);
  },
  methods: {
    async deleteAndRefresh(id) {
      let { value } = await this.$swal.fire({
        title: "Delete Shipment profile rate",
        html: "Are you sure you want to delete this Shipment profile rate?",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting Shipment profile rate...",
          html: "this may only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "shipmentprofilerates/DESTROY_SHIPMENT_PROFILE_RATE",
          {
            shipmentProfileId: this.payload.shipmentProfileId,
            shipmentProfileRateId: id
          }
        );
        this.$swal({
          title: "Success",
          html: "Shipment profile rate has been deleted",
          icon: "info"
        });
      }
    },
    getShipmentProfileRates(payload) {
      this.$store
        .dispatch(this.module, payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getShipmentProfileRates(payload);
    }
  }
};
</script>
